import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { useLanguage } from "@/i18n/LanguageContext";
import { Layers } from "lucide-react";

export function OverlaySettingsCard({ overlayMode, setOverlayMode }) {
  const { t } = useLanguage();

  return (
    <Card className="col-span-12 bento-card" data-testid="overlay-settings-card">
      <CardHeader className="pb-4">
        <CardTitle className="flex items-center gap-2 text-white font-['Outfit']">
          <Layers className="w-5 h-5" />
          {t("overlayMode")}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <Label htmlFor="overlay-mode" className="text-white">{t("overlayOtherWindows")}</Label>
            <p className="text-zinc-500 text-sm">
              {t("overlayDescription")}
            </p>
          </div>
          <Switch
            id="overlay-mode"
            checked={overlayMode}
            onCheckedChange={setOverlayMode}
            data-testid="overlay-mode-switch"
            aria-label={t("overlayMode")}
          />
        </div>
        
        {overlayMode && (
          <div className="p-3 bg-blue-500/10 border border-blue-500/20 rounded-lg">
            <p className="text-blue-400 text-sm">
              <strong>{t("overlayActive")}:</strong> {t("overlayActiveDescription")}
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
